import { Helmet, HelmetProvider } from 'react-helmet-async';
import SettingsDasboardIcon from "../../media/settings_dasboard.png";
import MachinesDashboardIcon from "../../media/vending_machines_dasboard.png";
import OrdersDashboardIcon from "../../media/orders_dasboard.png";

import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useUserCategoriesHook from '../../api/userCategories';

const Home = () => {
    const { auth } = useAuth();

    // Use the user categories hook to fetch categories
    const { getGuestCategories, getAdminCategories } = useUserCategoriesHook({});

    // Fetch appropriate categories based on auth state
    const { data: categoriesData, isLoading } = auth?.userInfo ? getAdminCategories : getGuestCategories;

    if (isLoading) {
        return <div>Loading...</div>;
    }

    // Extract available categories from the fetched data
    const categories = categoriesData?.categories || [];

    // Helper function to check if a path exists in the user's categories
    const hasCategoryPath = (path) => categories.some(category => category.path === path);

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>I-mall Project</title>
                    <meta property='og:title' content='Home Page' key='title' />
                </Helmet>
            </HelmetProvider>

            <div className='d-flex justify-content-center align-items-center' style={{ height: '30vh' }}>
                <span className='text-muted'>
                    <h3 className='home-animation-h3'>
                        <span className='home-animation-span'>i-mall</span>
                        <span className='home-animation-span'>Project</span>
                    </h3>
                </span>
            </div>

            {/* Icon Section */}
            <div className='container mt-4'>
                <div className='row justify-content-center'>

                    {/* Conditionally render the Orders Icon with Title if the user has access to /admin/auth/orders */}
                    {hasCategoryPath('/admin/auth/orders') && (
                        <div className="col-12 col-sm-6 col-md-4">
                            <div className="text-center dashboard-main-icon-block mb-4">
                                <Link to='/admin/auth/orders' className='dashboard-main-icon'>
                                    <img
                                        src={OrdersDashboardIcon}
                                        alt='Orders Dashboard Icon'
                                        className='img-fluid'
                                    />
                                </Link>
                                <p className='dashboard-main-icon-title'>Orders</p>
                            </div>
                        </div>
                    )}

                    {/* Conditionally render the Machines Icon with Title if the user has access to /admin/auth/machines */}
                    {hasCategoryPath('/admin/auth/machines') && (
                        <div className="col-12 col-sm-6 col-md-4">
                            <div className="text-center dashboard-main-icon-block mb-4">
                                <Link to='/admin/auth/machines' className='dashboard-main-icon'>
                                    <img
                                        src={MachinesDashboardIcon}
                                        alt='Machines Dashboard Icon'
                                        className='img-fluid'
                                    />
                                </Link>
                                <p className='dashboard-main-icon-title'>Machines</p>
                            </div>
                        </div>
                    )}

                    {/* Conditionally render the Profile Icon with Title if the user has access to /admin/auth/account/profile */}
                    {hasCategoryPath('/admin/auth/account/profile') && (
                        <div className="col-12 col-sm-6 col-md-4">
                            <div className="text-center dashboard-main-icon-block mb-4">
                                <Link to='/admin/auth/account/profile' className='dashboard-main-icon'>
                                    <img
                                        src={SettingsDasboardIcon}
                                        alt='Profile Dashboard Icon'
                                        className='img-fluid'
                                    />
                                </Link>
                                <p className='dashboard-main-icon-title'>Profile</p>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
}

export default Home;
